import {
  ICertMasterPlatformEmailExists,
  IError,
  IQueryHookOptions,
} from '@comptia-sso/core';
import {
  UseMutateAsyncFunction,
  useMutation,
  useQueryClient,
} from 'react-query';

// Services.
import { getCertMasterPlatformEmailExists } from 'services';

type RedeemAccessKeyFunction = UseMutateAsyncFunction<
  ICertMasterPlatformEmailExists,
  IError,
  string
>;

type CertMasterPlatformEmailExists = [
  RedeemAccessKeyFunction,
  IQueryHookOptions,
];

export const useCertMasterPlatformEmailExists =
  (): CertMasterPlatformEmailExists => {
    const queryClient = useQueryClient();
    const { error, isError, isLoading, mutateAsync } = useMutation<
      ICertMasterPlatformEmailExists,
      IError,
      string
    >((email: string) => getCertMasterPlatformEmailExists(email), {
      onSuccess: () => {
        queryClient.invalidateQueries(['profile', 'entitlements']);
      },
    });

    return [mutateAsync, { error, isError, isLoading }];
  };
